<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">On Hold Report</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                    style="width:1200px"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.salesorderno}}</td>
                      <td class="text-xs-left"><a href="">{{ props.item.amebookingno}}</a></td>
                      <td class="text-xs-left">{{ props.item.slbookingno}}</td>
                      <td class="text-xs-left">{{ props.item.shippingline}}</td>
                      <td class="text-xs-left">{{ props.item.containerno}}</td>
                      <td class="text-xs-left">{{ props.item.containertype}}</td>
                      <td class="text-xs-left">{{ props.item.reasonforonhold}}</td>
                      <td class="text-xs-left">{{ props.item.onholdcontainerimage}}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order No', value: 'salesorderno' },
        { text: 'AME Booking No', value: 'amebookingno' },
        { text: 'SL Booking No', value: 'slbookingno' },
        { text: 'Shipping Line', value: 'shippingline' },
        { text: 'Container No', value: 'containerno' },
        { text: 'Container Type', value: 'containertype' },
        { text: 'Reason for on Hold', value: 'reasonforonhold' },
        { text: 'On Hold Container Image', value: 'onholdcontainerimage' }
      ],
      desserts: [
        {
          no: '1',
          salesorderno: '986325417',
          amebookingno: 'AME / FF / 145287963',
          slbookingno: '9876769856',
          shippingline: 'MAERSK LINE',
          containerno: 'MSKU123654',
          containertype: '20` Dry Standard',
          reasonforonhold: 'Leakage from container is major problem in storage and transport'
        },
        {
          no: '2',
          salesorderno: '986325417',
          amebookingno: 'AME / FF / 145287963',
          slbookingno: '9876769856',
          shippingline: 'MAERSK LINE',
          containerno: 'MSKU123654',
          containertype: '20` Dry Standard',
          reasonforonhold: 'Leakage from container is major problem in storage and transport'
        },
        {
          no: '3',
          salesorderno: '986325417',
          amebookingno: 'AME / FF / 145287963',
          slbookingno: '9876769856',
          shippingline: 'MAERSK LINE',
          containerno: 'MSKU123654',
          containertype: '20` Dry Standard',
          reasonforonhold: 'Leakage from container is major problem in storage and transport'
        }
      ],
      show1: true,
      show2: false,
      show3: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Onholdreport.vue